import React from 'react';
import { TrendingUpIcon } from 'lucide-react';
interface UrgencyBannerProps {
  bookedCount: number;
}
export function UrgencyBanner({
  bookedCount
}: UrgencyBannerProps) {
  if (bookedCount === 0) return null;
  return <div className="bg-surface-warm border-b border-border px-6 py-2.5" data-id="element-720">
      <div className="flex items-center gap-2 text-sm" data-id="element-721">
        <span className="relative flex h-2 w-2" data-id="element-722">
          <span className="animate-pulse-dot absolute inline-flex h-full w-full rounded-full bg-urgent opacity-75" data-id="element-723"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-urgent" data-id="element-724"></span>
        </span>
        <TrendingUpIcon className="w-4 h-4 text-text-secondary" data-id="element-725" />
        <span className="text-text-secondary" data-id="element-726">
          <span className="font-semibold text-text-primary" data-id="element-727">
            {bookedCount} locations
          </span>{' '}
          booked this week — inventory moving fast
        </span>
      </div>
    </div>;
}